<template>
  <div>
    <div class="header">
      <div class="left">
        <div class="logo">
          <img src="../../assets/img/logossg.png" />
        </div>
        <div class="line"></div>
        <div class="back" @click="back">返回项目列表</div>
      </div>

      <div class="company">{{ this.$route.query.projectName }}</div>
    </div>
    <div class="content" v-if="edit == false">
      <div class="leftdiv">
        <div class="leftnav">
          <div class="title">嗖嗖数据中心</div>
          <div class="tip">
            <div>批该报告仅供内部人员使用，切勿外传</div>
            <div>如涉及到隐私泄露，将追究法律责任</div>
          </div>
          <div class="line"></div>
          <div class="tabdiv">
            <div class="tabs">
              <div
                :class="v.id == checked ? 'tab checked' : 'tab'"
                style="padding: 0 15px"
                v-for="(v, k) in all"
                :key="k"
                :data-permissions="v.btnPermissions"
                v-has
                @click="tab(v.id)"
              >
                {{ v.name }}
              </div>
            </div>
          </div>
          <div>
            <div class="contentlist">
              <div class="contentline"></div>
              <div class="block" v-for="(m, l) in recordList" :key="l">
                <div class="time">{{ m.createTime }}</div>
                <div class="tipnum">
                  <span class="tip1">{{ m.operationContent }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightdiv">
        <div v-if="checked == 0">
          <span style="margin-right: 20px">日期筛选</span>
          <el-date-picker
            v-model="createTime"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            value-format="yyyy-MM"
            @change="changeData"
          >
          </el-date-picker>
        </div>
        <div class="nav" v-if="checked == 1 || checked == 2">
          <div>
            <span style="margin-right: 20px">日期筛选</span>
            <el-date-picker
              v-model="createTime"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="changeData"
            >
              >
            </el-date-picker>
          </div>
          <div>
            <button class="btn subbtn" @click="download">下载最新</button>
          </div>
        </div>
        <div class="tablediv">
          <div class="ibox" style="margin-bottom: 0">
            <div class="table">
              <h4>文件列表</h4>
            </div>
          </div>
          <div class="table">
            <el-table
              :data="list"
              :header-cell-style="{ background: '#f8fafb', color: '#303140' }"
            >
              <el-table-column
                label="文件名"
                prop="fileName"
                min-width="12"
                align="left"
              >
              </el-table-column>
              <el-table-column
                label="大小"
                prop="fileSize"
                min-width="15"
                align="left"
              >
              </el-table-column>

              <el-table-column
                label="操作"
                prop="status"
                min-width="13"
                align="left"
                fixed="right"
              >
                <template slot-scope="scope">
                  <i
                    class="el-icon-upload"
                    @click="downloadone(scope.row.id)"
                    style="color: #6669e3; cursor: pointer"
                    >下载</i
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <page
            :page="pageNum"
            :pagesize.sync="pageSize"
            :total="total"
            @currentChange="cur"
            @enter="cur"
            v-show="total > 0"
            :pageNum="pageNum"
          ></page>
        </div>
      </div>
    </div>
    <div class="authority" v-if="edit == true">
      <div class="content">
        <p>您没有权限查看页面</p>
        <p>如需开通请联系系统管理员</p>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  created() {
    let btnPermissionsStr = sessionStorage.getItem("btnPermissions");
    if (
      btnPermissionsStr.indexOf("view:ssg:data:deliver:bill") > -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:wait:entry:detail") > -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:entry_sign:detail") > -1
    ) {
      this.checked = "0";
    } else if (
      btnPermissionsStr.indexOf("view:ssg:data:deliver:bill") <= -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:wait:entry:detail") <= -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:entry_sign:detail") <= -1
    ) {
      this.edit = true;
    }
    if (
      btnPermissionsStr.indexOf("view:ssg:data:deliver:bill") > -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:wait:entry:detail") <= -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:entry_sign:detail") <= -1
    ) {
      this.checked = "0";
      this.all.splice(1, 2);
    }
    if (
      btnPermissionsStr.indexOf("view:ssg:data:deliver:bill") > -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:wait:entry:detail") <= -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:entry_sign:detail") > -1
    ) {
      this.checked = "0";
      this.all.splice(1, 1);
    }
    if (
      btnPermissionsStr.indexOf("view:ssg:data:deliver:bill") <= -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:wait:entry:detail") > -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:entry_sign:detail") <= -1
    ) {
      this.checked = "1";
      this.all.splice(0, 1);
      this.all.splice(1, 2);
    } else if (
      btnPermissionsStr.indexOf("view:ssg:data:deliver:bill") <= -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:wait:entry:detail") > -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:entry_sign:detail") > -1
    ) {
      this.checked = "1";
      this.all.splice(0, 1);
    } else if (
      btnPermissionsStr.indexOf("view:ssg:data:deliver:bill") <= -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:wait:entry:detail") <= -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:entry_sign:detail") > -1
    ) {
      this.checked = "2";
      this.all.splice(0, 2);
    } else if (
      btnPermissionsStr.indexOf("view:ssg:data:deliver:bill") > -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:wait:entry:detail") > -1 &&
      btnPermissionsStr.indexOf("view:ssg:data:entry_sign:detail") <= -1
    ) {
      this.checked = "0";
      this.all.splice(2, 1);
    }
    this.loadData();
    this.operation();
  },

  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      edit: false,
      createTime: [],
      recordList: [{}],
      list: [],
      all: [
        {
          id: "0",
          name: "交付账单",
          btnPermissions: "view:ssg:data:deliver:bill",
        },
        {
          id: "1",
          name: "待入职",
          btnPermissions: "view:ssg:data:wait:entry:detail",
        },
        {
          id: "2",
          name: "在职+待员工签字",
          btnPermissions: "view:ssg:data:entry_sign:detail",
        },
      ],
      checked: "",
    };
  },
  methods: {
    changeData(e) {
      this.createTime = e ? e : [];
      if (e !== null) {
        this.pageNum = 1;
      }
      this.loadData();
    },
    operation() {
      const params = {
        dataType: this.checked,
        pageNum: 1,
        pageSize: 10,
      };
      return this.$axios
        .get("data/statistics/operation/page", {
          params,
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.recordList = res.data.data.list;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    loadData() {
      const params = {
        dataType: this.checked,
        monthDateStart: this.createTime[0] ? this.createTime[0] : "",
        monthDateEnd: this.createTime[1] ? this.createTime[1] : "",
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      return this.$axios
        .get("data/statistics/page", {
          params,
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.list = res.data.data.list;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    download() {
      const params = "dataType=" + this.checked;
      return this.$axios
        .post("data/statistics/create", params)
        .then((res) => {
          if (res.data.status == 1) {
            this.$message.success(res.data.message);
            this.loadData();
            this.operation();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    //下载单个明细
    downloadone(id) {
      this.$confirm("下载到本地, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: 'warning'idid
        iconClass: "el-icon-caveat",
      })
        .then(() => {
          var param = "id=" + id;
          this.$axios
            .post("data/statistics/download", param)
            .then(async (res) => {
          
              const url = res.data.data.fileUrl;
              const fileName = res.data.data.fileName;
              try {
                const response = await fetch(url);
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }

                const blob = await response.blob();
                const downloadUrl = URL.createObjectURL(blob);

                // 创建隐藏的 <a> 标签
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = fileName;

                // 触发点击事件
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                URL.revokeObjectURL(downloadUrl);
              } catch (error) {
                console.error("Error downloading file:", error);
              }
              // 触发点击事件
              link.click();
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cur(val) {
      this.pageNum = val;
      this.loadData();
    },
    back() {
      this.$router.push({
        path: "/ssgSplat",
      });
    },
    tab(v) {
      this.checked = v;
      this.createTime = [];
      this.pageNum = 1;
      this.pageSize = 10;
      this.operation();
      this.loadData();
    },
  },
};
</script>
  
  
  <style src="../../assets/css/common/nav.less" scoped lang="less"></style>
  <style src="../../assets/css/common/operating.less" scoped lang="less"></style>
  <style src="../../assets/css/common/table.less" scoped lang="less"></style>
  <style src="../../assets/css/common/card.less" scoped lang="less"></style>
  <style src="../../assets/css/common/details.less" scoped lang="less"></style>
<style src="../../assets/css/common/eattribute.less" scoped lang="less"></style>

  <style scoped lang="less">
.header {
  height: 63px;
  background-color: #f2f5f8;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  .left {
    display: flex;
    align-items: center;
  }
  .line {
    width: 1px;
    height: 21px;
    background-color: #d9dbe2;
    margin: 0 37px;
  }
  .back {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    cursor: pointer;
  }
  .logo {
    margin-left: 30px;
  }
}
.content {
  display: flex;
  margin: 50px 100px;

  .leftdiv {
    width: 20%;
    height: 100%;
    border: 1px solid #d9dbe2;
    border-radius: 15px;
    .leftnav {
      padding: 20px;
      .title {
        font-weight: 700;
        color: #303140;
        font-size: 18px;
        margin: 20px 0;
      }
      .tip {
        margin: 40px 0 100px 0;
        font-size: 14px;
        font-weight: 400;
        color: #8a8a9a;
        line-height: 30px;
      }
      .line {
        height: 1px;
        background: #4e5969;
        text-align: center;
        margin: 20px -20px;
      }
      .tabdiv {
        // margin-bottom: 50px;
      }
    }
  }
}
.authority {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin: 100px auto;

  .content {
    text-align: center;
    margin: 50px auto;
    font-size: 24px;
    font-weight: bold;
    color: #303140;
    justify-content: center;
  }
}
.contentlist {
  display: block;
  font-size: 14px;

  .contentline {
    width: 1px;
    margin-right: 25px;
    background-color: #d9dbe2;
    display: inline;
  }
  .block {
    margin-bottom: 10px;
  }
  .time {
    color: #8a8a;
  }
  .tip1 {
    color: #303140;
    margin-right: 3px;
  }
  .tip2 {
    color: #6669e3;
    margin-left: 3px;
  }
}
.rightdiv {
  margin-left: 100px;
  width: 70%;
  .tablediv {
    margin-top: 50px;
  }
  .nav {
    display: flex;
    justify-content: space-between;
  }
}
</style>
  